import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { operation_type } from '../components/new-table-list/interface';
import { WarnIcon } from './imgs/shared-icon';

/**
 * 刪除確認訊息的 operation 選項
 * @param {string} caption
 * @param {string} [delete_type]
 * @param {(0 | 1 | 2)} [custom_action]
 * @param {(string | string[])} [name_alias] name 的别名，在 item_selected 的 keys 里具有唯一性
 * @return {*}  {operation_type}
 */
export const delete_operation = (
  caption: string,
  delete_type?: string,
  custom_action?: 0 | 1 | 2,
  name_alias?: string | string[],
  icon?: JSX.Element
): operation_type => ({
  caption,
  action: custom_action !== undefined ? custom_action : 2,
  modal_title: `delete_item`,
  modal_title_values: { type: delete_type ? <FormattedMessage id={delete_type}></FormattedMessage> : '' },
  width: '40vw',
  icon,
  modal_message: ({ props, formatMessage }: any) => {
    let name: string = '';
    if (name_alias) {
      if (typeof name_alias === 'string') {
        name = props?.item_selected?.[name_alias];
      } else {
        if (props?.item_selected) {
          const keys: string[] = Object.keys(props?.item_selected);
          for (let i = 0; i < keys?.length; i++) {
            const name_index: number = name_alias?.indexOf(keys?.[i]);
            if (name_index >= 0) {
              name = props?.item_selected?.[keys?.[i]];
              break;
            }
          }
        }
      }
    }
    return (
      <div className='ant-col-sm-24' style={{ display: 'table', fontSize: 14 }}>
        <WarnIcon style={{ verticalAlign: ' middle', paddingRight: '14px' }} />
        <div style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          <FormattedMessage
            id={`${props.selected_row_keys?.length ? 'batch_delete_msg' : 'delete_msg'}`}
            values={{
              item: (
                <Fragment>
                  {props.selected_row_keys?.length ? (
                    <b>{props.selected_row_keys?.length}</b>
                  ) : (
                    <Fragment>
                      {delete_type && formatMessage({ id: delete_type?.toLocaleLowerCase() })}&nbsp;
                      <b style={{wordBreak:'break-all'}}>{props?.item_selected?.name || props?.item_selected?.tag_name || name}</b>
                    </Fragment>
                  )}
                </Fragment>
              )
            }}
          ></FormattedMessage>
          {!!props.selected_row_keys?.length && (
            <Fragment>
              {delete_type && formatMessage({ id: delete_type?.toLocaleLowerCase() })}
              <FormattedMessage id='data' />
            </Fragment>
          )}
        </div>
      </div>
    );
  }
});
